export * from './date_config';
export * from './enums';
export * from './environment';
export * from './events';
export * from './fixed_sku_bundle_config';
var FREE_SHIPPING_THRESHOLD_DOLLARS = 85;
var V9_SHIPPING_COST_DOLLARS = 15;
var UI_FLAGS = {
    HIDE_MARKETING_BANNER: 'hideMarketingBanner',
    HIDE_MIXED_RECIPES_PLAN_PROMO: 'hideMixedRecipesPlanPromo',
    HIDE_ONBOARDING_WELCOME_PAGE: 'hideOnboardingWelcomePage',
    HIDE_SIGNUP_FEEDING_GUIDE: 'hideSignupFeedingGuide',
    HIDE_SIGNUP_WELCOME: 'hideSignupWelcome',
    HIDE_SWITCH_TO_FLEX_PLAN_PROMO: 'hideSwitchToFlexPlanPromo',
    SKIP_FEEDING_GUIDES_FEEDBACK_SURVEY: 'skipFeedingGuidesFeedbackSurvey',
};
export { FREE_SHIPPING_THRESHOLD_DOLLARS, UI_FLAGS, V9_SHIPPING_COST_DOLLARS };
